import type { AgentModelConfig, LLMConfigListResponse, LLMConfigSummary } from "@/lib/types";

/** Validate gateway list body so a bad payload is not mistaken for "no models". */
export function readLlmConfigListItems(res: LLMConfigListResponse): {
  items: LLMConfigSummary[];
  badShape: boolean;
} {
  const raw = res.items;
  if (!Array.isArray(raw)) {
    return { items: [], badShape: true };
  }
  return { items: raw, badShape: false };
}

/** Build `spec.model` fields that match a row from `/v1/llm/configs` before the gateway back-fill. */
export function modelFromLlmConfigSummary(
  config: LLMConfigSummary,
  legacyFallback: AgentModelConfig,
): AgentModelConfig {
  const slug = config.provider_slug ?? config.slug;
  if (!slug) {
    return {
      ...legacyFallback,
      provider_kind: config.provider_kind ?? legacyFallback.provider_kind,
      model: config.model,
      temperature: config.temperature,
      max_output_tokens: config.max_output_tokens,
      base_url: config.base_url ?? legacyFallback.base_url,
    };
  }
  return {
    provider: slug,
    provider_kind: config.provider_kind ?? null,
    model: config.model,
    temperature: config.temperature,
    max_output_tokens: config.max_output_tokens,
    base_url: config.base_url ?? null,
  };
}
